// useAudio.js
import { useRef, useState, useEffect, useCallback } from 'react';

export default function useAudio(src, { volume = 1, loop = false } = {}) {
  const audioRef   = useRef(new Audio(src));
  const [ready, ok] = useState(false);             // true after first user‑unlock

  // unlock on first user gesture
  const unlock = useCallback(async () => {
    try {
      const a = audioRef.current;
      a.volume = volume;
      a.loop   = loop;
      await a.play();          // allowed ONLY in a gesture context
      a.pause();               // pause immediately—just unlocks audio stack
      ok(true);
    } catch (err) {
      console.warn('Audio unlock failed:', err);
    }
  }, [volume, loop]);

  // tidy up on unmount
  useEffect(() => () => audioRef.current?.pause(), []);

  const play  = () => ready && audioRef.current.play();
  const pause = () => ready && audioRef.current.pause();
  const stop  = () => {
    if (!ready) return;
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  };

  return { ready, unlock, play, pause, stop };
}
